import React from "react";
import { Eye, ArrowUUpLeft } from "@phosphor-icons/react";
import { useAuth } from "../contexts/AuthContext";

/**
 * TesterPreviewBanner — egy diszkrét felső sáv, amely CSAK akkor jelenik
 * meg, ha admin user (Tamás) a `Tester nézet` előnézet módban van.
 * Tester user soha nem lát ilyen banner-t (a `previewAsTester` flag
 * kizárólag admin sessionben aktiválható az AuthContextben).
 */
export default function TesterPreviewBanner() {
  const { previewAsTester, setPreviewAsTester, isReallyAdmin } = useAuth();
  if (!isReallyAdmin || !previewAsTester) return null;

  return (
    <div
      data-testid="tester-preview-banner"
      className="sticky top-0 z-[60] flex items-center justify-between gap-4 px-5 py-2.5 text-[12.5px]"
      style={{
        background: "linear-gradient(90deg, rgba(94,80,247,0.18) 0%, rgba(94,80,247,0.10) 100%)",
        borderBottom: "1px solid rgba(94,80,247,0.35)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      <div className="flex items-center gap-2 text-[#c8c1ff]">
        <Eye size={14} weight="fill" color="#a294ff" />
        <span className="tracking-[0.06em]">
          Tester nézet előnézet — így látja egy sima tesztelő az ügynököket.
        </span>
      </div>
      <button
        type="button"
        data-testid="tester-preview-exit"
        onClick={() => setPreviewAsTester(false)}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md font-semibold text-white transition hover:-translate-y-0.5"
        style={{
          background: "linear-gradient(135deg, #5e50f7 0%, #4F46E5 100%)",
          boxShadow: "0 6px 16px rgba(94,80,247,0.36)",
          fontSize: "11.5px",
        }}
      >
        <ArrowUUpLeft size={12} weight="bold" />
        Vissza admin nézetbe
      </button>
    </div>
  );
}
